// extracted by mini-css-extract-plugin
export var cardContainer = "_o7-0";
export var cardHeader = "_o7-2";
export var collapsedState = "_o7-3";
export var dragHandle = "_o7-5";
export var dragHandleIcon = "_o7-6";
export var dragging = "_o7-1";
export var titleArea = "_o7-4";